import { Breadcrumb } from 'antd';
import { BreadcrumbWrapper } from '@components/shared/StyledComponents';
import Link from 'next/link';
import { HomeOutlined } from '@ant-design/icons';

interface Path {
  pathName: string;
  url?: string;
}

interface PageBreadcrumbsProps {
  paths: Path[];
}

export const PageBreadcrumbs = ({ paths }: PageBreadcrumbsProps) => {
  return (
    <BreadcrumbWrapper>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link href="/">
            <a>
              <HomeOutlined /> Home
            </a>
          </Link>
        </Breadcrumb.Item>

        {paths?.map((path, index) => (
          <Breadcrumb.Item key={path.pathName}>
            {index === paths.length - 1 ? <span>{path.pathName}</span> : <Link href={path.url}>{path.pathName}</Link>}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </BreadcrumbWrapper>
  );
};
